import { render } from "./AppBurgerMenu.vue?vue&type=template&id=bd4cdcb0&scoped=true&ts=true"
import script from "./AppBurgerMenu.vue?vue&type=script&lang=ts"
export * from "./AppBurgerMenu.vue?vue&type=script&lang=ts"

import "./AppBurgerMenu.vue?vue&type=style&index=0&id=bd4cdcb0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd4cdcb0"]])

export default __exports__